import React from "react";
import PropTypes from "prop-types";
// Material imports
import makeStyles from "@mui/styles/makeStyles";
import Typography from "@mui/material/Typography";
const useStyles = makeStyles({
  simpleCardContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-end",
    alignItems: "center",
    width: 145,
    height: 135,
    boxShadow: "0px 0px 7px 0px rgba(0,0,0,0.2)",
    margin: 1
  },
  imageContainer: {
    display: "flex",
    position: "absolute",
    top: 16,
    justifyContent: "center",
    alignItems: "center",
    height: 70,
    width: 70
  },
  image: {
    maxHeight: "100%",
    maxWidth: "100%"
  },
  textPadding: {
    marginLeft: 2,
    marginRight: 2,
    marginBottom: 8,
    textTransform: "none"
  }
});
const SimpleCard = ({
  title,
  imageSource,
  icon,
  containerStyles
}) => {
  const classes = useStyles();
  const isImageOrIcon = imageSource || icon;
  return /*#__PURE__*/React.createElement("div", {
    className: `${classes.simpleCardContainer} ${containerStyles}`
  }, isImageOrIcon && /*#__PURE__*/React.createElement("div", {
    className: classes.imageContainer
  }, imageSource ? /*#__PURE__*/React.createElement("img", {
    src: imageSource,
    className: classes.image
  }) : icon), /*#__PURE__*/React.createElement(Typography, {
    color: "textPrimary",
    className: isImageOrIcon && classes.textPadding
  }, title));
};
export default SimpleCard;
SimpleCard.propTypes = {
  title: PropTypes.string.isRequired,
  imageSource: PropTypes.string,
  icon: PropTypes.node,
  containerStyles: PropTypes.string
};